Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = compositeAggsReducer;

var _constants = require('../constants');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function compositeAggsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (action.type === _constants.UPDATE_COMPOSITE_AGGS) {
    var aggsResponse = Object.values(action.aggregations) && Object.values(action.aggregations)[0];
    var fieldName = Object.keys(action.aggregations)[0];
    if (!aggsResponse) return state;
    var buckets = aggsResponse.buckets || [];
    var parsedAggs = buckets.map(function (bucket) {
      var doc_count = bucket.doc_count,
          key = bucket.key,
          hitsData = bucket[fieldName];
      return _extends({
        _doc_count: doc_count,
        _key: key[fieldName]
      }, hitsData && hitsData.hits.hits[0]);
    });
    return _extends({}, state, _defineProperty({}, action.component, parsedAggs));
  }

  return state;
}